import { useBreakpoint } from 'gatsby-plugin-breakpoints';

export function useBreakpoints() {
  const { desktop = false, laptop = false, mobile = false, tablet = false } = useBreakpoint();
  return { desktop, laptop, mobile, tablet };
}
